$(document).ready(function() {
   $("#RegisterForm-practitioner").keyup(function() {
      var dInput = $(this).val();
     
     /* Enter Practitioner Code's*/
     var practitioner1 = 'NICKY';             var practitioner52 = '';                 var practitioner103 = '';
     var practitioner2 = '';                  var practitioner53 = '';                 var practitioner104 = '';
     var practitioner3 = '';                  var practitioner54 = '';                 var practitioner105 = '';
     var practitioner4 = '';                  var practitioner55 = '';                 var practitioner106 = '';
     var practitioner5 = '';                  var practitioner56 = '';                 var practitioner107 = '';
     var practitioner6 = '';                  var practitioner57 = '';                 var practitioner108 = '';
     var practitioner7 = '';                  var practitioner58 = '';                 var practitioner109 = '';
     var practitioner8 = '';                  var practitioner59 = '';                 var practitioner110 = '';
     var practitioner9 = '';                  var practitioner60 = '';                 var practitioner111 = '';
     var practitioner10 = '';                 var practitioner61 = '';
     var practitioner11 = '';                 var practitioner62 = '';
     var practitioner12 = '';                 var practitioner63 = '';
     var practitioner13 = '';                 var practitioner64 = '';
     var practitioner14 = '';                 var practitioner65 = '';
     var practitioner15 = '';                 var practitioner66 = '';
     var practitioner16 = '';                 var practitioner67 = '';
     var practitioner17 = '';                 var practitioner68 = '';
     var practitioner18 = '';                 var practitioner69 = '';
     var practitioner19 = '';                 var practitioner70 = '';
     var practitioner20 = '';                 var practitioner71 = '';
     var practitioner21 = '';                 var practitioner72 = '';
     var practitioner22 = '';                 var practitioner73 = '';
     var practitioner23 = '';                 var practitioner74 = '';
     var practitioner24 = '';                 var practitioner75 = '';
     var practitioner25 = '';                 var practitioner76 = '';
     var practitioner26 = '';                 var practitioner77 = '';
     var practitioner27 = '';                 var practitioner78 = '';
     var practitioner28 = '';                 var practitioner79 = '';
     var practitioner29 = '';                 var practitioner80 = '';
     var practitioner30 = '';                 var practitioner81 = '';
     var practitioner31 = '';                 var practitioner82 = '';
     var practitioner32 = '';                 var practitioner83 = '';
     var practitioner33 = '';                 var practitioner84 = '';
     var practitioner34 = '';                 var practitioner85 = '';
     var practitioner35 = '';                 var practitioner86 = '';
     var practitioner36 = '';                 var practitioner87 = '';
     var practitioner37 = '';                 var practitioner88 = '';
     var practitioner38 = '';                 var practitioner89 = '';
     var practitioner39 = '';                 var practitioner90 = '';
     var practitioner40 = '';                 var practitioner91 = '';
     var practitioner41 = '';                 var practitioner92 = '';
     var practitioner42 = '';                 var practitioner93 = '';
     var practitioner43 = '';                 var practitioner94 = '';
     var practitioner44 = '';                 var practitioner95 = '';
     var practitioner45 = '';                 var practitioner96 = '';
     var practitioner46 = '';                 var practitioner97 = '';
     var practitioner47 = '';                 var practitioner98 = '';
     var practitioner48 = '';                 var practitioner99 = '';
     var practitioner49 = '';                 var practitioner100 = '';
     var practitioner50 = '';                 var practitioner101 = '';
     var practitioner51 = '';                 var practitioner102 = '';
     
      if(dInput == practitioner1 || dInput == practitioner2 || dInput == practitioner3 || dInput == practitioner4 || dInput == practitioner5 || dInput == practitioner6 ||
        dInput == practitioner7 || dInput == practitioner8 || dInput == practitioner9 || dInput == practitioner10 || dInput == practitioner11 || dInput == practitioner12 ||
        dInput == practitioner13 || dInput == practitioner14 || dInput == practitioner15 || dInput == practitioner16 || dInput == practitioner17 || dInput == practitioner18 ||
        dInput == practitioner19 || dInput == practitioner20 || dInput == practitioner21 || dInput == practitioner22 || dInput == practitioner23 || dInput == practitioner24 ||
        dInput == practitioner25 || dInput == practitioner26 || dInput == practitioner27 || dInput == practitioner28 || dInput == practitioner29 || dInput == practitioner30 ||
        dInput == practitioner31 || dInput == practitioner32 || dInput == practitioner33 || dInput == practitioner34 || dInput == practitioner35 || dInput == practitioner36 ||
        dInput == practitioner37 || dInput == practitioner38 || dInput == practitioner39 || dInput == practitioner40 || dInput == practitioner41 || dInput == practitioner42 ||
        dInput == practitioner43 || dInput == practitioner44 || dInput == practitioner45 || dInput == practitioner46 || dInput == practitioner47 || dInput == practitioner48 ||
        dInput == practitioner49 || dInput == practitioner50 || dInput == practitioner51 || dInput == practitioner52 || dInput == practitioner53 || dInput == practitioner54 ||
        dInput == practitioner55 || dInput == practitioner56 || dInput == practitioner57 || dInput == practitioner58 || dInput == practitioner59 || dInput == practitioner60 ||
        dInput == practitioner61 || dInput == practitioner62 || dInput == practitioner63 || dInput == practitioner64 || dInput == practitioner65 || dInput == practitioner66 ||
        dInput == practitioner67 || dInput == practitioner68 || dInput == practitioner69 || dInput == practitioner70 || dInput == practitioner71 || dInput == practitioner72 || 
        dInput == practitioner73 || dInput == practitioner74 || dInput == practitioner75 || dInput == practitioner76 || dInput == practitioner77 || dInput == practitioner78 || 
        dInput == practitioner79 || dInput == practitioner80 || dInput == practitioner81 || dInput == practitioner82 || dInput == practitioner83 || dInput == practitioner84 ||
        dInput == practitioner85 || dInput == practitioner86 || dInput == practitioner87 || dInput == practitioner88 || dInput == practitioner89 || dInput == practitioner90 ||
        dInput == practitioner91 || dInput == practitioner92 || dInput == practitioner93 || dInput == practitioner94 || dInput == practitioner95 || dInput == practitioner96 ||
        dInput == practitioner97 || dInput == practitioner98 || dInput == practitioner99 || dInput == practitioner100 || dInput == practitioner101 || dInput == practitioner102 ||
        dInput == practitioner103 || dInput == practitioner104 || dInput == practitioner105 || dInput == practitioner106 || dInput == practitioner107 || dInput == practitioner108 ||
        dInput == practitioner109 || dInput == practitioner110 || dInput == practitioner111 ){
         if (!dInput == '' ){ 
           $('#customer_tag').val('Practitioner-code');
            // $('#create_customer button').attr({disabled:true});
         } 
      }else{
        $('#customer_tag').val('Customer');
        // $('#create_customer button').attr({disabled:false});
      }

// $('#RegisterForm-practitioner').keyup(function(){
//     var pass    =   $('#RegisterForm-practitioner').val();
//     var cpass   =   $(this).val();
//     if(pass!=cpass){
//         alert("Hello! I am an alert box!!");
//         $('.submit-button').attr({class:'button submit-button red'});
//         $('.submit-button').attr({disabled:true});
//     }
//     else{
//       alert("Hello! Hardeep from else!");
//         $('.submit-button').attr({class:'button submit-button green'});
//         $('.submit-button').attr({disabled:false});
//     }
// });
     

   });


  
  }); 




